"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-benedetto-po": {
    "e570b9fb": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "skipSearch": false
    }],
    "bardelle-camatta-gorgo": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "40a452e6": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "skipSearch": false
    }],
    "bardelle": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a3a9c062": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "skipSearch": false
    }],
    "gorgo": [{
      "hkey": "70a01ff6",
      "slug": "bardelle-gorgo",
      "name": "Bardelle-Gorgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;